import { z } from 'zod';
/**
 * Delete Partner Contact Response
 * DELETE /api/v2/partner/contacts/:id
 */ export const DeletePartnerContactResponseSchema = z.object({
    success: z.literal(true)
});

//# sourceMappingURL=delete-partner-contact.schema.js.map